import {Box, Button, Grid, TextField, Typography} from "@mui/material";
import {useState} from "react";
import {getDriverPortalRentalInfo} from "./DriverPortalService";
import {createTheme, responsiveFontSizes} from '@mui/material/styles';
import {ThemeProvider} from "@emotion/react";
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../../routes";

let responsiveFontSizesTheme = createTheme();
responsiveFontSizesTheme = responsiveFontSizes(responsiveFontSizesTheme);

export default function DriverPortalPage() {
    const [rentalAgreementNumber, setRentalAgreementNumber] = useState("");
    const [validationText, setValidationText] = useState("");
    const [failureMessage, setFailureMessage] = useState("");
    const navigate = useNavigate();

    const handleRentalAgreementNumberInputChange = (event) => {
        setRentalAgreementNumber(event.target.value);
        setFailureMessage("")
    };

    const handleValidationTextInputChange = (event) => {
        setValidationText(event.target.value);
        setFailureMessage("")
    };

    const handleViewRentalInfoClick = () => {
        if (rentalAgreementNumber === "") return;
        if (validationText === "") return;
        getDriverPortalRentalInfo(rentalAgreementNumber, validationText)
            .then((responseData) => {
                console.log("response")
                console.log(responseData);
                let missingRentalData = responseData.data.rentalEvent === null || responseData.data.rentalEvent === undefined
                let missingAutoExtensions = responseData.data.autoExtensions === null || responseData.data.autoExtensions === undefined || responseData.data.autoExtensions.length === 0
                if (missingRentalData && missingAutoExtensions) {
                    throw Error("Could not find rental event")
                }
                setFailureMessage("")
                navigate(ROUTES.DRIVER_PORTAL_RENTAL_INFO, { state: responseData.data })
            })
            .catch((failure) => {
                console.log("Failed to get rental info")
                console.log(failure)
                setFailureMessage("No rental found. Please re-enter information and try again.")
            })
    };

    const viewRentalButtonDisabled = () => {
        function isEmpty(value) {
            return value === null || value === undefined || value.length === 0;
        }

        return isEmpty(rentalAgreementNumber) || isEmpty(validationText);
    }

    function submitFormOnFormEnter(ev) {
        if (ev.key === 'Enter') {
            handleViewRentalInfoClick();
            ev.preventDefault();
        }
    }

    return (
        <Grid container justifyContent='center' align='center'>
            <Box sx={{maxWidth: '400px'}}>
                <ThemeProvider theme={responsiveFontSizesTheme}>
                    <Grid item xs={12}>
                        <Typography variant='h3'>
                            Welcome to Hertz
                            for Rideshare!
                        </Typography>
                    </Grid>
                </ThemeProvider>
                <Grid item xs={12} sx={{py: 1}}>
                    <svg width="72" height="72" viewBox="0 0 72 72" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M56.76 18.03C56.16 16.26 54.48 15 52.5 15H19.5C17.52 15 15.87 16.26 15.24 18.03L9 36V60C9 61.65 10.35 63 12 63H15C16.65 63 18 61.65 18 60V57H54V60C54 61.65 55.35 63 57 63H60C61.65 63 63 61.65 63 60V36L56.76 18.03ZM19.5 48C17.01 48 15 45.99 15 43.5C15 41.01 17.01 39 19.5 39C21.99 39 24 41.01 24 43.5C24 45.99 21.99 48 19.5 48ZM52.5 48C50.01 48 48 45.99 48 43.5C48 41.01 50.01 39 52.5 39C54.99 39 57 41.01 57 43.5C57 45.99 54.99 48 52.5 48ZM15 33L19.5 19.5H52.5L57 33H15Z"
                            fill="#45484A"/>
                    </svg>
                </Grid>
                <Grid item xs={12} sx={{pb: 3}}>
                    <Typography>
                        Here you can view important information regarding your rental. Easily see your rental
                        status,
                        upcoming extension date, and much more.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{pb: 3}}>
                    <TextField
                        variant='outlined'
                        name='rentalAgreementNumber'
                        type='name'
                        label='Rental Agreement #'
                        InputLabelProps={{
                            shrink: true
                        }}
                        onKeyDown={submitFormOnFormEnter}
                        fullWidth
                        value={rentalAgreementNumber}
                        onChange={handleRentalAgreementNumberInputChange}
                        sx={{pb: 2}}
                        data-testid='raNumberTextInput'
                    />
                    <TextField
                        variant='outlined'
                        name='validationText'
                        type='name'
                        label='Last Name or Last 4 of Drivers License'
                        InputLabelProps={{
                            shrink: true
                        }}
                        onKeyDown={submitFormOnFormEnter}
                        fullWidth
                        value={validationText}
                        onChange={handleValidationTextInputChange}
                        sx={{pb: 1}}
                        data-testid='validationTextInput'
                    />
                    <Typography align='right' sx={{color: '#F44336'}} variant='subtitle2'>
                        {failureMessage}
                    </Typography>
                </Grid>
                <Grid item xs={12} align='right'>
                    <Button
                        onClick={handleViewRentalInfoClick}
                        size='medium'
                        variant='contained'
                        color='secondary'
                        id='viewRentalBtn'
                        disabled={viewRentalButtonDisabled()}
                        data-testid='viewRentalButton'
                    >
                        View Rental Info
                    </Button>
                </Grid>
            </Box>
        </Grid>
    )
}